import { getErrorMessage, handleApiError } from '@/utils/apiErrorHandler';
import type { ToastType } from '@/shared/context/ToastContext';

type ToastFn = (type: ToastType, message: string) => void;

let globalToast: ToastFn | null = null;

export function registerToastHandler(handler: ToastFn) {
  globalToast = handler;
}

export function handleErrorApi(error: unknown, fallback?: string): string {
  const message = getErrorMessage(error) || fallback || 'Une erreur est survenue';
  globalToast?.('error', message);
  return message;
}

export function showSuccess(message: string) {
  globalToast?.('success', message);
}

export function showWarning(message: string) {
  globalToast?.('warning', message);
}

export function showInfo(message: string) {
  globalToast?.('info', message);
}

export { handleApiError, getErrorMessage };
